module.exports = "/_next/static/images/row2-3-2x-6a0518ef1df267853bed4c7dc436637b.png";